var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIpls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-9.035 -2.617 710.003 290.678",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,858.898 H 612.283 V 0 H 0 Z",
    id: "path18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.333333, 0, 0, -1.333333, -56.756664, 919.206604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(301.5342,623.9827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -18.271,-86.542 H -40.53 L -22.258,0 Z",
    style: {
      fill: "#29235c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    clipPath: "url(#clipPath20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(354.6862,605.8771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.435,0 -6.703,-0.557 -9.801,-1.663 -3.101,-1.107 -5.925,-2.713 -8.471,-4.816 l -7.308,-34.052 c 2.101,-2.989 5.037,-5.344 8.804,-7.059 3.764,-1.718 7.807,-2.575 12.125,-2.575 7.641,0 14.09,2.658 19.351,7.973 5.259,5.316 7.89,11.794 7.89,19.434 0,6.422 -2.132,11.82 -6.395,16.197 C 11.931,-2.189 6.532,0 0,0 m -61.293,-103.152 25.747,121.258 h 22.091 l -0.829,-4.32 c 3.099,1.77 6.337,3.127 9.716,4.07 3.376,0.94 6.836,1.412 10.382,1.412 5.423,0 10.518,-1.025 15.281,-3.074 4.761,-2.05 8.83,-4.846 12.21,-8.388 3.376,-3.546 6.061,-7.781 8.055,-12.706 1.993,-4.93 2.99,-10.217 2.99,-15.864 0,-6.756 -1.274,-13.097 -3.82,-19.02 -2.549,-5.925 -5.981,-11.103 -10.3,-15.529 -4.318,-4.43 -9.413,-7.92 -15.28,-10.466 -5.871,-2.548 -12.127,-3.819 -18.771,-3.819 -5.094,0 -9.857,0.803 -14.285,2.408 -4.43,1.603 -8.305,3.957 -11.626,7.06 l -9.302,-43.022 z",
    style: {
      fill: "#29235c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(451.6889,658.6985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -25.747,-121.258 H -48.005 L -23.254,-4.984 Z",
    style: {
      fill: "#29235c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(440.725,550.3967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 12.791,14.451 c 4.65,-3.986 9.328,-6.977 14.035,-8.969 4.707,-1.994 9.496,-2.99 14.369,-2.99 4.539,0 8.221,0.885 11.047,2.658 2.823,1.771 4.234,4.041 4.234,6.81 0,1.882 -0.805,3.46 -2.408,4.734 -1.608,1.272 -3.961,2.297 -7.06,3.073 l -15.946,3.488 c -7.087,1.55 -12.516,4.345 -16.278,8.388 -3.765,4.041 -5.649,9.054 -5.649,15.033 0,8.637 3.1,15.502 9.302,20.598 6.202,5.091 14.563,7.64 25.083,7.64 6.977,0 13.675,-1.137 20.1,-3.405 6.42,-2.271 12.18,-5.565 17.274,-9.883 L 68.437,47.839 c -4.431,3.321 -8.889,5.839 -13.372,7.558 -4.486,1.715 -8.832,2.574 -13.04,2.574 -3.986,0 -7.143,-0.775 -9.468,-2.325 -2.324,-1.553 -3.488,-3.654 -3.488,-6.312 0,-2.106 0.773,-3.795 2.324,-5.066 1.55,-1.275 4.208,-2.299 7.975,-3.073 l 15.779,-3.489 c 7.31,-1.551 12.9,-4.347 16.776,-8.387 3.877,-4.044 5.814,-8.945 5.814,-14.701 0,-4.211 -0.94,-8.113 -2.823,-11.711 -1.883,-3.599 -4.46,-6.701 -7.723,-9.302 -3.268,-2.603 -7.144,-4.65 -11.628,-6.146 -4.485,-1.495 -9.33,-2.242 -14.536,-2.242 -7.971,0 -15.611,1.329 -22.921,3.987 C 10.797,-8.139 4.761,-4.542 0,0",
    style: {
      fill: "#29235c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(292.5656,635.3204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.1,0 -5.759,1.106 -7.974,3.322 -2.215,2.215 -3.322,4.925 -3.322,8.139 0,3.875 1.438,7.252 4.318,10.132 2.88,2.879 6.202,4.32 9.969,4.32 3.098,0 5.754,-1.109 7.971,-3.323 2.215,-2.217 3.322,-4.873 3.322,-7.973 C 14.284,10.74 12.845,7.334 9.965,4.402 7.086,1.465 3.764,0 0,0",
    style: {
      fill: "#93c01f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(119.8259,599.692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.953,-4.724 2.501,-9.544 4.494,-14.416 10.957,-26.791 48.628,-39.099 70.582,-17.074 0.727,0.728 4.292,3.968 5.117,4.729 2.195,-9.328 -8.665,-30.85 -15.545,-38.683 -17.861,-20.335 -45.998,-17.017 -66.382,-0.247 -19.664,16.177 -32.708,41.63 -34.097,65.541",
    style: {
      fill: "#93c01f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(134.0055,524.2749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 6.119,-2.419 14.193,-3.598 21.35,-3.211 14.607,0.789 30.732,13.182 39.108,34.619 9.298,23.798 7.435,51.475 -16.917,60.341 -13.416,4.884 -42.131,-1.296 -54.079,-9.964 -1.744,-1.265 -3.852,-3.202 -5.379,-4.767 -5.198,10.636 -0.74,32.921 9.418,40.944 20.035,15.826 73.117,15.668 93.925,1.288 C 115.971,99.522 108.341,59.253 90.121,28.396 70.247,-5.261 46.374,-18.437 23.294,-13.539 15.16,-11.812 7.21,-7.151 0,0",
    style: {
      fill: "#29235c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(84.2004,597.6336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.459,6.155 -0.155,12.22 0.998,18.013 10.834,60.376 55.99,70.066 89.359,65.12 103.66,63.307 116.279,58.382 126.356,51.135 117.348,53.559 108.144,55.4 98.702,55.879 75.275,57.065 53.807,50.471 41.682,33.667 34.747,24.054 33.451,13.239 35.656,1.852",
    style: {
      fill: "#93c01f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIpls);
export default __webpack_public_path__ + "static/media/logo-ipls.f395da4ce1a0665e06ab82667fd21d90.svg";
export { ForwardRef as ReactComponent };